/**
 * The screen transition's phase (GameView.setTransition; drawn in the post pass, shaders/transition.glsl).
 * The integrator animates one number, 0 clear .. 1 covered and back; the picture runs one way through
 * 0..2 instead: 0..1 bubbles rise in from the bottom and grow until they fill the view, 1 covered, 1..2
 * they burst from the bottom up onto the new screen. Which half it is in is read from which way the
 * number moves. Pure.
 */

/** The previous `p` a phase was made from. */
const coverOf = (phase: number): number => (phase <= 1 ? phase : 2 - phase);
/** Drawn twice at the same `p` is standing still (2 - (2 - p) need not come back exactly as p). */
const SAME = 1e-9;

/** The phase for cover `p` (clamped to 0..1), given the phase last drawn. */
export function transitionPhase(p: number, prevPhase: number): number {
  const c = Math.min(1, Math.max(0, p));
  if (c <= 0) return 0;
  if (c >= 1) return 1;
  const before = coverOf(prevPhase);
  // Covering (or clear) goes on covering while p rises; once covered, p falling is the burst.
  if (prevPhase < 1) return c >= before - SAME ? c : 2 - c;
  return c <= before + SAME ? 2 - c : c;
}
